import { authInstance as axios } from 'utils/axiosInterceptor';

const retrieveBridgeWebhooks = async ({
  pageSize = 10,
  pageIndex = 1,
  type,
  search,
}) => {
  const params = {};

  if (pageSize && pageIndex) {
    params.pageSize = pageSize;
    params.pageIndex = pageIndex;
  }

  if (type) {
    params.type = type;
  }

  if (search) {
    params.search = search;
  }

  return axios.get(`${process.env.REACT_APP_BRIDGE_WEBHOOK_URL}/webhooks`, {
    params,
  });
};

const fetchWebhookDetails = async (webhookId) => {
  return axios.get(
    `${process.env.REACT_APP_BRIDGE_WEBHOOK_URL}/webhooks/${webhookId}`
  );
};

export default {
  retrieveBridgeWebhooks,
  fetchWebhookDetails,
};
